import React from "react";
import Typography from "@material-ui/core/Typography";
const Lead = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Lead
      </Typography>
      <Typography paragraph variant="h5">
        Manage potential customer to grow company market
      </Typography>
      <Typography paragraph variant="body1">
        Lead is one of the features under the CRM module to manage potential
        customer master data which ready to be approached by the sales team. It
        contains any information regarding the contact person, personal or
        company background, and address details of each lead.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Lead list. It is
        displayed like a table that contains download functions, sort, filter,
        and global search on the header area, and contains data navigation and
        refresh function on the footer area. The data column that appears in
        this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Lead ID</b>
        <br />
        Indicates the ID of the Lead.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Lead Name</b>
        <br />
        Indicates the full name of the Lead.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Contact Name</b>
        <br />
        Indicates the main contact name of the Lead.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Phone Number</b>
        <br />
        Indicates the contact phone number of the Lead.
      </Typography>
      <Typography paragraph variant="body1">
        <b>City</b>
        <br />
        Indicates the city location of the Lead.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Lead Status</b>
        <br />
        Indicates the status of the Lead. There are 2 statuses: Prospect and
        Customer.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Assigned To</b>
        <br />
        Indicates who takes the assignment to do the approach of the Lead.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 4 buttons that appear on each row of Lead data with
        specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Whatsapp Chat Lead</b>
        <br />
        This button only appears if the Lead has a valid phone number. It is
        used to automatically redirect to WhatsApp API to send a conversation to
        the Lead.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Lead</b>
        <br />
        This button only appears if the Lead status is 'Prospect'. It is used to
        edit the Lead data. The Lead data is not editable once the status is
        'Customer' already.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Lead Detail</b>
        <br />
        This button is used to navigate to the Lead detail which contains some
        tabs with details below:
        <ul>
          <li>
            <b>Basic Info</b> : This tab is to display the Lead data.
          </li>
          <li>
            <b>Sales Cards</b> : This tab is to display any Sales Cards related
            to the Lead.
          </li>
          <li>
            <b>Visits</b> : This tab is to display any Visits related to the
            Lead.
          </li>
          <li>
            <b>Quotations</b> : This tab is to display any Quotations related to
            the Lead.
          </li>
          <li>
            <b>Attachments</b> : This tab is to display any Attachments related
            to the Lead.
          </li>
          <li>
            <b>Notes</b> : This tab is to display any Notes related to the Lead.
          </li>
        </ul>
        When opening the Lead detail, there will be 2 buttons appearing on the
        top section. The first button is 'Convert To Customer', which is used to
        automatically convert Lead data to Customer data. The second button is
        'Edit Lead' which is used to edit the Lead data. Both 2 buttons only
        appear when the Lead status is 'Prospect'.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Lead</b>
        <br />
        This button only appears if the Lead status is 'Prospect'. It is used to
        delete the Lead data. The Lead data is undeletable once the status is
        'Customer' already.
      </Typography>
    </React.Fragment>
  );
};

export default Lead;
